import { Avatar, Box, Button, Container, Stack, Typography } from "@mui/joy";
import { useFirestoreQuery } from "@react-query-firebase/firestore";
import { collection, orderBy, query, where } from "firebase/firestore";
import * as React from "react";
import { useSelector } from "react-redux";
import HeaderBackButton from "../components/HeaderBackButton";

import { db } from "../config/firebase";
import { History } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { HistoryItem } from "../components/HistoryItem";

export function NotificationData() {
  const userinfo = useSelector((state) => state.useInfos);
  const { id } = userinfo;

  const ref = query(
    collection(db, "users", id, "transactions"),
    orderBy("timestamp", "desc")
  );
  const querY = useFirestoreQuery(["notifications"], ref);

  if (querY.isLoading) {
    return <Typography>Loading...</Typography>;
  }

  const snapshot = querY.data;

  const getAllDocsWithoutField = (fieldName) => {
    const docsWithoutField = snapshot.docs.filter((doc) => {
      const data = doc.data();
      return !(fieldName in data);
    });

    return docsWithoutField;
  };

  return getAllDocsWithoutField("seen").map((docSnapshot, index) => {
    const data = docSnapshot.data();
    const { transaction_type, cointitle, seen } = data;
    console.log(seen);
    const isCredit = transaction_type === "Credit";

    const switchImage = (key) => {
      switch (key) {
        case "BTC":
          return "../images/coins/btc.png";
        case "ETH":
          return "../images/coins/eth.png";
        case "BNB":
          return "../images/coins/bnb.png";
        case "TRX":
          return "../images/coins/tron.png";
        case "USDT":
          return "../images/coins/usdt.png";
        default:
          return "../images/coins/usdt.png";
      }
    };

    return (
      <HistoryItem
        key={index}
        data={data}
        itemCode={
          isCredit ? "images/call-received@2x.png" : "images/call-made@2x.png"
        }
        id={docSnapshot.id}
        imageCode={switchImage(cointitle)}
        frameBorder={isCredit ? "1px solid green" : "1px solid #8a919e"}
      />
    );
  });
}

export const NoTransaction = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box display={"flex"} justifyContent={"center"}>
        <Stack
          spacing={2}
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Avatar variant="outlined" size="lg">
            <History fontSize="xl2" />
          </Avatar>
          <Typography level="body-md">No data yet.</Typography>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => navigate("/buy")}
          >
            Buy crypto
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default function Notification() {
  const notificationLength = useSelector((state) => state.notification);
  return (
    <>
      <HeaderBackButton title={"Notifications"} />
      <Container>
        {notificationLength > 0 ? <NotificationData /> : <NoTransaction />}
      </Container>
    </>
  );
}
